import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
  Button,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRepeaters, activateRepeater } from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";
// import Pagination from "../common/Pagination";
import { fabStyle } from "../common/style";

const RepeaterList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector((state) => state.repeater.repeaters);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      dispatch(fetchRepeaters({ page, limit }));
    }
  }, [dispatch, page, user]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleActivation = (repeater) => {
    console.log("repeater in handleActivation", repeater);
    dispatch(activateRepeater({ repeater })).then(() => {
      console.log("activation success");
      dispatch(fetchRepeaters({ page, limit }));
    });
  };

  const renderActivation = (repeater) => {
    console.log("repeater", repeater);
    if (!repeater.isActivated) {
      return (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleActivation(repeater)}
        >
          활성화
        </Button>
      );
    }
    return null;
  };

  const renderRepeaters = () =>
    rows.map((repeater) => (
      <TableRow
        key={repeater.devEUI}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <Link
            to={`/repeaters/${repeater.devEUI}/update`}
            className="TableCell-link"
          >
            {repeater.devEUI}
          </Link>
        </TableCell>
        <TableCell>{repeater.devAddr}</TableCell>
        <TableCell>{repeater.name}</TableCell>
        {/* <TableCell>{repeater.Application.Organization.displayName}</TableCell> */}
        <TableCell>{repeater.Application.description}</TableCell>
        <TableCell>{new Date(repeater.createdAt).toLocaleString()}</TableCell>
        <TableCell>{repeater.isActivated ? "활성" : "비활성"}</TableCell>
        <TableCell>{renderActivation(repeater)}</TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            작업장(리피터)
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="repeater-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>EUI</TableCell>
                  <TableCell>Dev Addr.</TableCell>
                  <TableCell>이름</TableCell>
                  {/* <TableCell>건설사</TableCell> */}
                  <TableCell>협력사</TableCell>
                  <TableCell>등록일시</TableCell>
                  <TableCell>상태</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderRepeaters()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/repeaters/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default RepeaterList;
